import { TypePolicies } from "@apollo/client"

export const objectAcl: TypePolicies = {
  ObjectAcl: {
    keyFields: ["object", ["id", "kind", "legalEntityId"]],
  },
}
